/** Підпис ТПА: «ТПА-1 · SONLY-265» */
export function fmtMachineLabel(m) {
  if (!m) return '—';
  const name = m.machine_name || m.name || '';
  const id = m.machine_identifier || m.identifier || '';
  if (id && name) return `${id} · ${name}`;
  return id || name || '—';
}

/** Сортування за ідентифікатором (ТПА-2 перед ТПА-10). */
export function sortMachinesByIdentifier(list) {
  return [...(list || [])].sort((a, b) => {
    const ia = String(a.machine_identifier || a.identifier || '');
    const ib = String(b.machine_identifier || b.identifier || '');
    const byId = ia.localeCompare(ib, 'uk', { numeric: true, sensitivity: 'base' });
    if (byId !== 0) return byId;
    const na = String(a.machine_name || a.name || '');
    const nb = String(b.machine_name || b.name || '');
    return na.localeCompare(nb, 'uk', { sensitivity: 'base' });
  });
}
